<script setup lang="ts">
import { useRoute } from "vue-router";

import { cardActions } from "@/action/cardActions";
import { getAlmInfo } from "@/backend/read/BackendReader";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { useDevLinks } from "@/composables/useDevLinks";
import { isFeatureEnabled } from "@/utils/env/feature";
import { injectStrict } from "@/utils/vue";

import DevLinksMenu from "./DevLinksMenu.vue";

const card = injectStrict(cardKey);
const route = useRoute();

const enabled = isFeatureEnabled(route, "gitlab-mrs") && getAlmInfo().hasDevLinks && !!card.almId;

const { devLinks, loaded, load } = useDevLinks(card.almId);

if (enabled) {
  void load();
}
</script>

<template>
  <ActionMenuDropdown v-if="enabled" :action="cardActions.openDevLinks" width="lg">
    <DevLinksMenu :dev-links="devLinks" :loading="!loaded" />
  </ActionMenuDropdown>
</template>
